import "./landing.css";
import { Link } from 'react-router-dom';
import { useState } from "react";
import { useLocation } from 'react-router-dom';
import icon1 from '../../Assets/icons/icon1.png'
import icon2 from '../../Assets/icons/icon2.png'
import icon3 from '../../Assets/icons/icon3.png'
import icon4 from '../../Assets/icons/icon4.png'
import icon5 from '../../Assets/icons/icon5.png'

export default function Landingpage() {
    const location = useLocation();

    const [languagePicked] = useState(() => {
        if (typeof window === "undefined") {
            return "fa";
        }

        return localStorage.getItem("siteLanguage") || "fa";
    });

    // Same logic as the navbar
    const isArabic = languagePicked === "ar";

    const landingPage =
        typeof window !== "undefined" && window.innerWidth >= 770
            ? "https://cdn.nasrollah.info/01.webp"
            : "https://cdn.nasrollah.info/landingMobile.webp";

    const isActive = (path) => {
        if (path === "/home") {
            return location.pathname === path || location.pathname === "/";
        }

        return location.pathname.startsWith(path);
    };

    const labels = isArabic
        ? {
              speeches: "خطابات",
              stories: "حكايا",
              audios: "صوت",
              productions: "إنتاجات",
          }
        : {
              speeches: "بيانات",
              stories: "داستان‌ها",
              audios: "صوت",
              productions: "تولیدات",
          };

    return (
        <div className="landingpage">
            <div className="slider">
                <img src={landingPage} alt="landing" />
            </div>

            <div className="icons">
                <Link
                    to="/speeches"
                    className={`icon ${
                        isActive("/speeches") ? "active" : ""
                    }`}
                >
                    <div className="icon-img">
                        <img src={icon2} alt="" />
                    </div>

                    <span>{labels.speeches}</span>
                </Link>

                <Link
                    to="/stories"
                    className={`icon ${
                        isActive("/stories") ? "active" : ""
                    }`}
                >
                    <div className="icon-img">
                        <img src={icon5} alt="" />
                    </div>

                    <span>{labels.stories}</span>
                </Link>

                <Link
                    to="/audios"
                    className={`icon ${
                        isActive("/audios") ? "active" : ""
                    }`}
                >
                    <div className="icon-img">
                        <img src={icon3} alt="" />
                    </div>

                    <span>{labels.audios}</span>
                </Link>

                <Link
                    to="/productions"
                    className={`icon ${
                        isActive("/productions") ? "active" : ""
                    }`}
                >
                    <div className="icon-img">
                        <img src={icon1} alt="" />
                    </div>

                    <span className="ic-desc">
                        {labels.productions}
                    </span>
                </Link>
            </div>
        </div>
    );
}